import { render } from "./Pos.vue?vue&type=template&id=45688fca&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=45688fca&scoped=true&lang=css"
import "./Pos.vue?vue&type=style&index=1&id=45688fca&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45688fca"]])

export default __exports__